<div class="row justify-content-md-center">
	<div class="bg-white">
		<div class="border-bottom p-3" *ngIf="!options.hideTitle">
			<h2>{{'contact_us.title' | translate}}</h2>
		</div>
		<sct-form *ngIf="form" [submitButtonText]="'g.submit'" [invalidFields]="invalidFields" [data]="{}" [name]="'contact_us'" [formBuilder]="form"
			[showCancelButton]="true" [cancelButtonText]="'g.back'" (formCancelled)="goBack()" (invlidateFieldsCallback)="notificationMessage.showMessage('translate|g.invalid_input')">
		</sct-form>
	</div>
</div>